module.exports = __webpack_public_path__ + "img/img_ghost_16@3x.41f81d52.png";